import React, { Fragment } from 'react';
import cx from 'classnames';

import { connect } from 'react-redux';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import UserBox from './Components/UserBox';
import { withRouter } from "react-router-dom";
import { userService } from '../../_services/user.service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import AppMobileMenu from "../AppMobileMenu";
import logo from "../../assets/utils/images/logo.png";

import {
    setEnableClosedSidebar,
    setEnableMobileMenu,
    setEnableMobileMenuSmall,
  } from "../../reducers/ThemeOptions";

class Header extends React.Component {

    constructor(props) {
        super(props);
        // this.state = {
        //     runningActivity: null
        // }
        this.currentUser = userService.getLoggedInUser();
    }

    componentDidMount() {
        // this.runningActivityObservable = RunningActivityHelper.runningActivityObservable.subscribe((val) => {
        //     this.setState({ runningActivity: val == null ? null : (val.isPaused ? null : val) });
        // });
    }

    // componentWillUnmount() {
    //     this.runningActivityObservable.unsubscribe();
    // }

    // getTimeInHoursMinutes = (seconds) => {
    //     let hours = Math.floor(seconds / 3600);
    //     let minutes = Math.floor((seconds - hours * 3600) / 60);
    //     return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
    // }

    toggleEnableClosedSidebar = () => {
        let { enableClosedSidebar, setEnableClosedSidebar } = this.props;
        setEnableClosedSidebar(!enableClosedSidebar);
    };

    render() {
        let {
          headerBackgroundColor,
          enableMobileMenuSmall,
          enableHeaderShadow,
        } = this.props;
        return (
          <Fragment>
            <ReactCSSTransitionGroup
              component="div"
              className={cx("app-header", headerBackgroundColor, {
                "header-shadow": enableHeaderShadow,
              })}
              transitionName="HeaderAnimation"
              transitionAppear={true}
              transitionAppearTimeout={1500}
              transitionEnter={false}
              transitionLeave={false}
              style={{ backgroundColor: "#4658ba", color: "white" }}
            >
              <AppMobileMenu />
              {/* <HeaderLogo hideMenu={this.props.hideMenu} /> */}
    
              <div
                className={cx("app-header__content", {
                  "header-mobile-open": enableMobileMenuSmall,
                })}
              >
                <FontAwesomeIcon
                  icon={this.props.enableClosedSidebar ? faBars : faTimes}
                  style={{ color: "white", cursor: "pointer", margin: "1.5rem", fontSize:'15px' }}
                  onClick={this.toggleEnableClosedSidebar}
                />
                <div className="app-header-left">
                  {!this.isMobile && (
                    // eslint-disable-next-line jsx-a11y/alt-text
                    <img
                      className="logo"
                      src={logo}
                      width="50"
                      style={{ marginRight: "20px" }}
                    />
                  )}
                  <div>
                    <span
                      className="logo"
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      Definitive Choice
                    </span>
                    <br />
                    <span style={{ fontSize: "14px" }}>
                      Where Better Decisions Lead to Better Outcomes
                    </span>
                  </div>
                </div>
                <div className="app-header-right">
                  {this.currentUser !== undefined && this.currentUser != null && (
                    <UserBox
                      name={`${this.currentUser.firstName} ${
                        this.currentUser.lastName
                      }`}
                    />
                  )}
                </div>
              </div>
            </ReactCSSTransitionGroup>
          </Fragment>
        );
      }
}

const mapStateToProps = (state) => ({
    enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
    closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
    headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
    enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch) => ({
    setEnableClosedSidebar: (enable) => dispatch(setEnableClosedSidebar(enable)),
    setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
    setEnableMobileMenuSmall: (enable) =>
        dispatch(setEnableMobileMenuSmall(enable)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Header));